// extracted by mini-css-extract-plugin
module.exports = {"styledRank":"eoZ9RevM","styledIconRank":"WDcypyTJ","wrapper":"p7U0ical","styledPlaceholder":"AczjlAOK"};